"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersService = void 0;
class UsersService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    putApiV1UsersLocale({ requestBody, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/users/locale',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request
                Not Found
                Internal Server Error
                `,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    getApiV1UsersLocale() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/users/locale',
        });
    }
    putApiV1UsersCountry({ requestBody, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v1/users/country',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Not valid one or more parameters`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
    postApiV1UsersSignout({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/users/signout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Not valid one or more parameters`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Bad Request
                Not Found
                Internal Server Error
                `,
                500: `Oops! Internal server error, try later.`,
            },
        });
    }
}
exports.UsersService = UsersService;
